/**
 * The additional cursors to keep: those still among `options`, or, while the schema has not loaded
 * (`options` undefined), every saved one except the main cursor.
 */
export function keptAdditionalCursors(
  selected: string[],
  cursor: string | null,
  options: { name: string }[] | undefined,
): string[] {
  if (!options) {
    return selected.filter((column) => column !== cursor);
  }
  return selected.filter((column) =>
    options.some((option) => option.name === column),
  );
}
